/* eslint-disable @typescript-eslint/no-explicit-any */

import Highcharts from "highcharts";

// For some reason, Highcharts overrides series.options.threshold to null in navigator options
// https://github.com/highcharts/highcharts/blob/53b04dca4c74d0092f691ce36a3c9a7a6ddeba90/ts/Core/Navigator.ts#L657
// repro: column series with only 0 values will get a bar that starts from padding, which makes no sense.
export default function fixNavigatorColumnSerieThreshold(H: typeof Highcharts) {
  H.wrap(
    // @ts-ignore
    Highcharts.seriesTypes.column.prototype,
    "translate",
    // @ts-ignore
    function (this: Highcharts.seriesTypes.column, proceed: any, ...args: unknown[]) {
      if (this.userOptions.isInternal) this.options.threshold = 0;
      return proceed.apply(this, args);
    },
  );
}
